import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function CTABanner() {
    return (
        <section
            data-testid="cta-banner"
            className="relative py-14 md:py-20 overflow-hidden"
        >
            <div
                aria-hidden="true"
                className="absolute inset-0"
                style={{
                    backgroundImage:
                        "url(https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=2400&q=85)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-brand-primary/92 via-brand-primary/80 to-brand-primary/60" />

            <div className="relative mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
                    <div className="md:col-span-8">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-10 bg-brand-accent" />
                            <span className="text-xs uppercase tracking-[0.24em] text-brand-accent font-semibold">
                                Ready when you are
                            </span>
                        </div>
                        <h2 className="font-serif-editorial text-4xl sm:text-5xl lg:text-6xl text-brand-bg leading-[1.05]">
                            From first keys
                            <br />
                            <em className="italic font-light text-brand-accent">
                                to future wealth.
                            </em>
                        </h2>
                    </div>
                    <div className="md:col-span-4 flex md:justify-end">
                        <Link
                            to="/contact"
                            data-testid="cta-banner-cta"
                            className="group inline-flex items-center gap-3 bg-brand-accent text-brand-primary px-8 py-5 rounded-full text-base font-bold hover:bg-brand-accentHover transition-colors"
                        >
                            Get in touch
                            <ArrowUpRight
                                size={18}
                                className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                            />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
